module.exports = __webpack_public_path__ + "media/images/mobile/title_pink_v-09edd450dc1310d676d64238bfceefba.gif";